export default __webpack_public_path__ + "static/media/exp-date.4f04a567.svg";